//import React, { useEffect, useState } from 'react';
//import {
//    ComposedChart,
//    Bar,
//    XAxis,
//    YAxis,
//    CartesianGrid,
//    Tooltip,
//    ResponsiveContainer,
//    Cell,
//} from 'recharts';
//import { useSelector } from "react-redux";
//import useAxiosInstance from '../../../services/useAxiosInstance';
//import { BarChart2, AlertCircle } from 'lucide-react';

//const ViolationRange = ({ startDate, endDate }) => {
//    const axiosInstance = useAxiosInstance();
//    const [violationData, setViolationData] = useState([]);
//    const [totalCount, setTotalCount] = useState(0);
//    const [loading, setLoading] = useState(true);
//    const communityId = useSelector((state) => state.auth.communityId);

//    // Color palette - consistent blues
//    const colorPalette = [
//        '#3b82f6', // blue-500
//        '#60a5fa', // blue-400
//        '#93c5fd', // blue-300
//        '#2563eb', // blue-600
//        '#1d4ed8', // blue-700
//    ];

//    useEffect(() => {
//        const fetchViolationData = async () => {
//            setLoading(true);
//            try {
//                const response = await axiosInstance.get(
//                    `/api/violation/boardMember/violationCounts/${communityId}`,
//                    {
//                        params: {
//                            startDate,
//                            endDate,
//                        },
//                    }
//                );

//                const data = response.data.violationTypes.map((item, index) => ({
//                    name: item.violationType,
//                    vendorType: parseFloat(item.percentage),
//                    percentage: parseFloat(item.percentage),
//                    fill: colorPalette[index % colorPalette.length], // Consistent color assignment
//                }));

//                setViolationData(data);
//                setTotalCount(response.data.totalCount);
//                console.log("violations", response.data);
//            } catch (error) {
//                console.error('Error fetching violation data:', error);
//            } finally {
//                setLoading(false);
//            }
//        };

//        fetchViolationData();
//    }, [communityId, startDate, endDate]);

//    const CustomTooltip = ({ active, payload }) => {
//        if (active && payload && payload.length) {
//            return (
//                <div className="bg-white p-3 border border-gray-200 rounded-md shadow-lg text-sm">
//                    <p className="font-semibold text-gray-800 mb-1">{payload[0].payload.name}</p>
//                    <p className="text-blue-600 font-medium">{`${payload[0].value.toFixed(2)}%`}</p>
//                </div>
//            );
//        }
//        return null;
//    };

//    const CustomYAxisTick = ({ x, y, payload }) => {
//        const maxLength = 20;
//        let label = payload.value;

//        // Truncate long labels
//        if (label.length > maxLength) {
//            label = label.substring(0, maxLength) + '...';
//        }

//        return (
//            <text
//                x={x - 10}
//                y={y + 4}
//                fontSize={13}
//                textAnchor="end"
//                fill="#4b5563" // text-gray-600
//                className="font-medium"
//            >
//                {label}
//            </text>
//        );
//    };

//    return (
//        <div className="mb-6 transition-all duration-300 hover:shadow-md rounded-xl">
//            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
//                {/* Header Section */}
//                <div className="p-6 border-b border-gray-100">
//                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
//                        <div>
//                            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-1">Most Violations</h2>
//                            <p className="text-sm text-gray-500">
//                                {startDate} to {endDate}
//                            </p>
//                        </div>
//                        <div className="flex items-center bg-blue-50 text-blue-600 px-4 py-2 rounded-lg shadow-sm">
//                            <BarChart2 size={18} className="mr-2" />
//                            <span className="font-semibold">{totalCount} total</span>
//                        </div>
//                    </div>
//                </div>

//                {/* Chart Section */}
//                <div className="p-4 sm:p-6">
//                    {loading ? (
//                        <div className="flex justify-center items-center h-64 text-gray-500">
//                            <div className="animate-pulse flex flex-col items-center">
//                                <div className="h-10 w-10 rounded-full bg-blue-200 mb-2"></div>
//                                <div className="h-4 w-32 bg-gray-200 rounded"></div>
//                            </div>
//                        </div>
//                    ) : violationData.length === 0 ? (
//                        <div className="flex flex-col justify-center items-center h-64 text-gray-500 p-6">
//                            <AlertCircle size={32} className="text-gray-400 mb-3" />
//                            <p className="text-center font-medium">No violation data available for the selected date range</p>
//                        </div>
//                    ) : (
//                        <div className="h-96 sm:h-80 md:h-96 lg:h-96 w-full">
//                            <ResponsiveContainer width="100%" height="100%">
//                                <ComposedChart
//                                    layout="vertical"
//                                    data={violationData}
//                                    margin={{
//                                        top: 10,
//                                        right: 20,
//                                        bottom: 20,
//                                        left: 120,
//                                    }}
//                                >
//                                    <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.5} horizontal={true} vertical={false} />
//                                    <XAxis
//                                        type="number"
//                                        domain={[0, 100]}
//                                        tickFormatter={(tick) => `${tick}%`}
//                                        axisLine={false}
//                                        tickLine={false}
//                                        padding={{ right: 10 }}
//                                        tick={{ fill: '#6b7280', fontSize: 12 }}
//                                    />
//                                    <YAxis
//                                        dataKey="name"
//                                        type="category"
//                                        scale="band"
//                                        axisLine={false}
//                                        tickLine={false}
//                                        tick={<CustomYAxisTick />}
//                                        width={120}
//                                        padding={{ top: 10, bottom: 10 }}
//                                    />
//                                    <Tooltip content={<CustomTooltip />} cursor={{ fill: '#f3f4f6' }} />
//                                    <Bar
//                                        dataKey="percentage"
//                                        barSize={24}
//                                        radius={[0, 4, 4, 0]}
//                                        animationDuration={800}
//                                        animationEasing="ease-out"
//                                    >
//                                        {violationData.map((entry, index) => (
//                                            <Cell
//                                                key={`cell-${index}`}
//                                                fill={entry.fill}
//                                                className="transition-opacity duration-300 hover:opacity-90"
//                                            />
//                                        ))}
//                                    </Bar>
//                                </ComposedChart>
//                            </ResponsiveContainer>
//                        </div>
//                    )}
//                </div>
//            </div>
//        </div>
//    );
//}

//export default ViolationRange;

import React, { useEffect, useState } from 'react';
import {
    ComposedChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell,
} from 'recharts';
import { useSelector } from "react-redux";
import useAxiosInstance from '../../../services/useAxiosInstance';
import { BarChart2, AlertCircle } from 'lucide-react';

const ViolationRange = ({ startDate, endDate }) => {
    const axiosInstance = useAxiosInstance();
    const [violationData, setViolationData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const roleId = useSelector((state) => state.auth.roleId);
    const communityId = useSelector((state) => state.auth.communityId);

    // Color palette - consistent blues
    const colorPalette = [
        '#3b82f6', // blue-500
        '#60a5fa', // blue-400
        '#93c5fd', // blue-300
        '#2563eb', // blue-600
        '#1d4ed8', // blue-700
    ];

    // Role-based community ID configuration
    const getCommunityIdForAPI = () => {
        switch (roleId) {
            case 1000: // Superadmin - All communities
                return 0;
            case 1001: // HOA Admin - Specific community
            case 1002: // Board Member - Specific community
                return communityId;
            default:
                return communityId;
        }
    };

    useEffect(() => {
        const fetchViolationData = async () => {
            setLoading(true);
            try {
                const communityIdParam = getCommunityIdForAPI();

                // Different endpoint for superadmin vs community-specific
                const endpoint = roleId === 1000
                    ? `/api/violation/admin/violationCounts/all` // All communities
                    : `/api/violation/boardMember/violationCounts/${communityIdParam}`;

                const response = await axiosInstance.get(endpoint, {
                    params: {
                        startDate,
                        endDate,
                        ...(roleId === 1000 && { includeAllCommunities: true })
                    },
                });

                const data = response.data.violationTypes.map((item, index) => ({
                    name: item.violationType,
                    vendorType: parseFloat(item.percentage),
                    percentage: parseFloat(item.percentage),
                    count: item.count || 0, // Actual count for tooltip
                    fill: colorPalette[index % colorPalette.length], // Consistent color assignment
                }));

                setViolationData(data);
                setTotalCount(response.data.totalCount);
                console.log("violations", response.data);
            } catch (error) {
                console.error('Error fetching violation data:', error);

                // Fallback data for demonstration
                if (roleId === 1000) {
                    setViolationData([
                        { name: "Parking Violations", percentage: 35.2, count: 42, fill: colorPalette[0] },
                        { name: "Noise Complaints", percentage: 28.5, count: 34, fill: colorPalette[1] },
                        { name: "Property Maintenance", percentage: 18.3, count: 22, fill: colorPalette[2] },
                        { name: "Pet Policy Violations", percentage: 12.1, count: 14, fill: colorPalette[3] },
                        { name: "Architectural Changes", percentage: 5.9, count: 7, fill: colorPalette[4] }
                    ]);
                    setTotalCount(119);
                } else {
                    setViolationData([
                        { name: "Parking Violations", percentage: 42.1, count: 8, fill: colorPalette[0] },
                        { name: "Noise Complaints", percentage: 26.3, count: 5, fill: colorPalette[1] },
                        { name: "Property Maintenance", percentage: 21.1, count: 4, fill: colorPalette[2] },
                        { name: "Pet Policy Violations", percentage: 10.5, count: 2, fill: colorPalette[3] }
                    ]);
                    setTotalCount(19);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchViolationData();
    }, [communityId, startDate, endDate, roleId]);

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div className="bg-white p-3 border border-gray-200 rounded-md shadow-lg text-sm">
                    <p className="font-semibold text-gray-800 mb-1">{data.name}</p>
                    <p className="text-blue-600 font-medium">{`${data.percentage.toFixed(2)}%`}</p>
                    {data.count && (
                        <p className="text-gray-600 text-xs">{`${data.count} violations`}</p>
                    )}
                </div>
            );
        }
        return null;
    };

    const CustomYAxisTick = ({ x, y, payload }) => {
        const maxLength = 20;
        let label = payload.value;

        // Truncate long labels
        if (label.length > maxLength) {
            label = label.substring(0, maxLength) + '...';
        }

        return (
            <text
                x={x - 10}
                y={y + 4}
                fontSize={13}
                textAnchor="end"
                fill="#4b5563" // text-gray-600
                className="font-medium"
            >
                {label}
            </text>
        );
    };

    // Role-based title and description
    const getHeaderInfo = () => {
        switch (roleId) {
            case 1000:
                return {
                    title: "Most Violations - System Overview",
                    description: "Across all communities",
                    period: `${startDate} to ${endDate}`
                };
            case 1001:
            case 1002:
                return {
                    title: "Most Violations - Community",
                    description: "Within your community",
                    period: `${startDate} to ${endDate}`
                };
            default:
                return {
                    title: "Most Violations",
                    description: "Violation breakdown",
                    period: `${startDate} to ${endDate}`
                };
        }
    };

    const headerInfo = getHeaderInfo();

    return (
        <div className="mb-6 transition-all duration-300 hover:shadow-md rounded-xl">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
                {/* Header Section */}
                <div className="p-6 border-b border-gray-100">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div>
                            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-1">
                                {headerInfo.title}
                            </h2>
                            <p className="text-sm text-gray-500">
                                {headerInfo.description} � {headerInfo.period}
                            </p>
                        </div>
                        <div className="flex items-center bg-blue-50 text-blue-600 px-4 py-2 rounded-lg shadow-sm">
                            <BarChart2 size={18} className="mr-2" />
                            <span className="font-semibold">{totalCount} total</span>
                        </div>
                    </div>
                </div>

                {/* Chart Section */}
                <div className="p-4 sm:p-6">
                    {loading ? (
                        <div className="flex justify-center items-center h-64 text-gray-500">
                            <div className="animate-pulse flex flex-col items-center">
                                <div className="h-10 w-10 rounded-full bg-blue-200 mb-2"></div>
                                <div className="h-4 w-32 bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    ) : violationData.length === 0 ? (
                        <div className="flex flex-col justify-center items-center h-64 text-gray-500 p-6">
                            <AlertCircle size={32} className="text-gray-400 mb-3" />
                            <p className="text-center font-medium">No violation data available for the selected date range</p>
                            <p className="text-center text-sm text-gray-400 mt-1">
                                {roleId === 1000 ? "Check system-wide settings" : "Try adjusting your date range"}
                            </p>
                        </div>
                    ) : (
                        <div className="h-96 sm:h-80 md:h-96 lg:h-96 w-full">
                            <ResponsiveContainer width="100%" height="100%">
                                <ComposedChart
                                    layout="vertical"
                                    data={violationData}
                                    margin={{
                                        top: 10,
                                        right: 20,
                                        bottom: 20,
                                        left: 120,
                                    }}
                                >
                                    <CartesianGrid stroke="#f5f5f5" strokeOpacity={0.5} horizontal={true} vertical={false} />
                                    <XAxis
                                        type="number"
                                        domain={[0, 100]}
                                        tickFormatter={(tick) => `${tick}%`}
                                        axisLine={false}
                                        tickLine={false}
                                        padding={{ right: 10 }}
                                        tick={{ fill: '#6b7280', fontSize: 12 }}
                                    />
                                    <YAxis
                                        dataKey="name"
                                        type="category"
                                        scale="band"
                                        axisLine={false}
                                        tickLine={false}
                                        tick={<CustomYAxisTick />}
                                        width={120}
                                        padding={{ top: 10, bottom: 10 }}
                                    />
                                    <Tooltip content={<CustomTooltip />} cursor={{ fill: '#f3f4f6' }} />
                                    <Bar
                                        dataKey="percentage"
                                        barSize={24}
                                        radius={[0, 4, 4, 0]}
                                        animationDuration={800}
                                        animationEasing="ease-out"
                                    >
                                        {violationData.map((entry, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={entry.fill}
                                                className="transition-opacity duration-300 hover:opacity-90"
                                            />
                                        ))}
                                    </Bar>
                                </ComposedChart>
                            </ResponsiveContainer>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ViolationRange;